import {WidgetSettings} from "src/interfaces/settings";
import Icon from "../Icon";
import {t} from "i18next";
import {ChatAssistantMetadata} from "src/interfaces/assistant";

interface AssistantGreetingProps {
  widgetSettings: WidgetSettings;
  metaData: ChatAssistantMetadata;
  greeting?: string;
}

export const AssistantGreeting = (props: AssistantGreetingProps) => {
  return (
    <div
      className={`rounded-lg px-[24px] py-[13px] `}
      style={{backgroundColor: props.metaData?.userMessageColor || "#E2E8F0"}}
    >
      <div className="flex items-center gap-4">
        <div
          className="h-8 w-8 p-2 mb-2 rounded-full flex items-center justify-center"
          style={{backgroundColor: props.widgetSettings ? props.widgetSettings?.buttonColor : "#000"}}
        >
          <Icon name="zap" iconSize="20px" />
        </div>
      </div>
      <p className="" style={{color: props.metaData?.userMessageTextColor || "#000"}}>
        {props.greeting || props.metaData?.greeting || t("ASSISTANT_CHAT_GREETING")}
      </p>
    </div>
  );
};
